module.exports = __webpack_public_path__ + "img/gift-clubfun-icon1.b5b1f13f.png";